import { Skeleton } from 'primereact/skeleton';
import classes from './ParallelIterationsModal.module.scss';
import useParallelIterationsTable from './useParalleIterationsTable';
import { User } from 'Interfaces/BDPortalInterfaces';
import { Avatar } from 'primereact/avatar';
import { getInitials } from 'utils/getInitials';
import { getBackgroundColor } from 'utils/avatarUtilities';

const TableLoadingSkeleton = () => {
  return <Skeleton height={'10rem'} />;
};

const AssigneeTemplate = ({ option }: { option: User | null }) => {
  return (
    <>
      {option ? (
        <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
          {option.ID > 0 && (
            <Avatar
              title={option.Name}
              id="profileAvatar"
              shape="circle"
              label={option.Name && getInitials(option?.Name)}
              style={{
                backgroundColor: getBackgroundColor(option.Name[0]),
                color: '#522D6E',
                marginRight: '0.5rem',
                height: '1.5rem',
                width: '1.5rem',
              }}
            />
          )}
          <div>{option.Name.length > 10 ? option.Name.substring(0, 8) + '...' : option.Name}</div>
        </div>
      ) : (
        <span>Unassigned</span>
      )}
    </>
  );
};

const ParallelIterationsTable = ({
  conceptName,
  isGoToOpportunityButtonVisible = true,
  isCreateNewIterationButtonVisible = true,
  showHeader = true,
  goToIterationCreateNewIterationCallBack,
}: {
  conceptName: string;
  isGoToOpportunityButtonVisible?: boolean;
  isCreateNewIterationButtonVisible?: boolean;
  showHeader?: boolean;
  goToIterationCreateNewIterationCallBack: () => void;
}) => {
  const {
    parallelIterationsData,
    handleGoToCreateNewIteration,
    handleGoToIteration,
    getColumnValue,
    isParallelIterationDataLoading,
    getAnalyst,
    getConceptsData,
  } = useParallelIterationsTable(conceptName, goToIterationCreateNewIterationCallBack);

  return (
    <div className={classes.iterationTableContainer}>
      {showHeader && (
        <div className={classes.containerHeading}>{`Parallel Iterations - ${conceptName}`}</div>
      )}
      {!isParallelIterationDataLoading ? (
        <table className={classes.iterationTable}>
          <thead className={classes.iterationTableHeader}>
            <th>Iteration</th>
            <th>Source</th>
            <th>Stage</th>
            <th>Status</th>
            <th>Analyst</th>
            <th>Strength</th>
            <th>Primary Partner</th>
            {/* {isGoToOpportunityButtonVisible && <th></th>} */}
            {isCreateNewIterationButtonVisible && <th></th>}
          </thead>
          <tbody>
            {parallelIterationsData.map((iteration, index) => (
              <tr
                key={`iteration-${index}`}
                className={classes.iterationTableRow}
                style={{
                  cursor: isGoToOpportunityButtonVisible ? 'pointer' : 'auto',
                }}
                onClick={() => {
                  if (isGoToOpportunityButtonVisible) {
                    handleGoToIteration(index);
                  }
                }}
              >
                <td>{iteration.iteration.IterationCounter}</td>
                <td>{getColumnValue(index, 'source')}</td>
                <td>{getColumnValue(index, 'stage')}</td>
                <td>{getColumnValue(index, 'status')}</td>
                <td>
                  <AssigneeTemplate option={getAnalyst(index)} />
                </td>
                <td title={getConceptsData(index).fullConceptData}>
                  {getConceptsData(index).shortenedConceptData}
                </td>
                <td>{getColumnValue(index, 'primaryPartner')}</td>
                {/* {isGoToOpportunityButtonVisible && (
                  <td
                    className={classes.linkText}
                    onClick={() => handleGoToIteration(index)}
                  >
                    Open
                  </td>
                )} */}
                {isCreateNewIterationButtonVisible && (
                  <td
                    className={classes.linkText}
                    onClick={() => handleGoToCreateNewIteration(index)}
                  >
                    Copy Details
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <TableLoadingSkeleton />
      )}
    </div>
  );
};

export default ParallelIterationsTable;
